import { add } from './tree/add.ts'
import { createTreesFromItems } from './tree/createTreesFromItems.ts'
import { exec } from './tree/exec.ts'
import { findNodeFromTrees } from './tree/findNodeFromTrees.ts'
import { flatNodes } from './tree/flatNodes.ts'
import { flatNodesWithParents } from './tree/flatNodesWithParents.ts'
import { remove } from './tree/remove.ts'
import { replace } from './tree/replace.ts'

// オブジェクトにまとめた方が分かりやすい気がしてきたので、途中から方向転換した
export const treeUtil = {
  exec,
  remove,
  add,
  replace,
  flatNodesWithParents,
  flatNodes,
  createTreesFromItems,
  findNodeFromTrees,
}
